import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT04860297&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT04860297`,
  },
];

class NCT04860297 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:2600,width:'100%',border:'none'}} title="NCT04860297" src="https://connect.trialscope.com/studies/a79e3360-7b7c-4aea-87a2-62f36ea73a5d?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT04860297;
